module.exports = __webpack_public_path__ + "img/img3.97dfa1df.png";